<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Sample Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading title="New Sample">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add sample'">
      <template #gated-content>
        <sample-form :submission="submission" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import SampleForm from "@/components/lab/sample/SampleForm";
import { notificationOptions } from "@/shared/toast-notification-options";
import { sampleNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { getModel } from '@/shared/fetch-utils';
import SampleAnalytesModel from "@/models/lab/SampleAnalytesModel";

const SampleRepository = LabRepositoryFactory.get("sample");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "SampleAdd",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    SampleForm,
  },
  data () {
    return {
      loading: true,
      submission_id: this.$route.params.submission_id || null,
      submission: null,
    }
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/samples",
            title: "Sample list",
          },
          ...this.submission_id ? [{
            icon: "fa-box",
            linkto: `/submissions/${this.submission_id}`,
            title: "Submission",
          }] : [],
        ],
      };
    },
  },
  async created () {
    this.loading = true

    if (this.submission_id) {
      this.submission = await getModel({
        model_type: "submission",
        id: this.submission_id,
        message: this.$bvToast
      })
    }

    this.loading = false
  },
  methods: {
    async submit(form_data, new_analytes) {
      try {
        const { data } = await SampleRepository.create(form_data);

        new_analytes.forEach(async ({ analyte }) => {
          const model = new SampleAnalytesModel({
            sample_id: this.sample_id,
            analyte_id: analyte.id,
          })
          await model.save()
        })

        this.addSuccess();
        this.$router.push(`/samples/${data.id}`);
      } catch ({ response }) {
        const { status, data } = response.response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    },
  },
  notifications: sampleNotifications,
};
</script>
